
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Transition } from "./Transition";
import React from "react";

function isOfType<P>(node: React.ReactNode, comp: React.FC<P>) {
    return React.isValidElement(node) && (node.type as any).displayName === (comp as any).displayName;
}

const Header: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
Header.displayName = "ModalHeader";

const Body: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
Body.displayName = "ModalBody";


interface MotiModalProps {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    hideX?: boolean;
    children?: React.ReactNode;
}

export default function MotiModal({ isOpen, setIsOpen, children, hideX=false }: MotiModalProps) {
    let header: React.ReactNode = null;
    let body: React.ReactNode = null;

    React.Children.forEach(children, (child) => {
        if (isOfType(child, Header)) header = (child as any).props.children;
        else if (isOfType(child, Body)) body = (child as any).props.children;
    });

    return (
        <Dialog
            id="templateCreatorModal"
            fullScreen
            open={isOpen}
            onClose={() => {
                setIsOpen(!isOpen);
            }}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: "relative" }}>
                <Toolbar style={{ backgroundColor: "var(--header-bg)" }}>
                    <IconButton
                        edge="start"
                        style={{ color: "#845adf" }}
                        color="inherit"
                        onClick={() => {
                            setIsOpen(!open);
                        }}
                        aria-label="close"
                    >
                        {!hideX && <CloseIcon />}
                    </IconButton>

                    {header}

                </Toolbar>
            </AppBar>
            <div
                style={{
                    height: "calc(100dvh - 65px)",
                    background: "rgba(240,241,247,1)",
                }}
            >
                {body}
            </div>
        </Dialog>
    );
}

MotiModal.Header = Header;
MotiModal.Body = Body;